const hereApiKey = 'VML_p4ERUorZnqDi7uqpu-tqswM3c-ts6M1Iuij3GyE';

export default hereApiKey;



// WEBPACK FOOTER //
// ./src/config/hereApiKey.js